import React,{  PureComponent, } from 'react'
import {Select, Checkbox, Alert, message} from 'antd';
import {isEmpty,isEmptyObject,trim,postHttpAction} from '@utils/utils';
import EssaModal from "@/components/EssaModal/EssaModal";
import Lang from "@components/Lang/Lang";
import './index.less';
import PropTypes from "prop-types";

/**
 * 类目选择器
 * @author FJJ
 * @version 1.0
 *
 * ============ ======= ======================================================
 * 2023/10/27     1.0     First version
 * 2023.12.11     2.0     由于需要校验有效类目显示，将查询类目改为页面 查询规则加载前
 *
 * @copyright 2021-2023, all rights reserved. Essa.cn
 **/
export default  class CategorySelect extends PureComponent {
    static propTypes = {
        changeAttrValues: PropTypes.func, // 修改属性值 方法
    };
    static defaultProps = {
        inxRule:'', // 当前序号
        selectedCategorySure:{},//已选 项

    };
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    /*
     * 加载
     * */
    loading(flag) {
        // this.setState({
        //     loading: flag,
        // });
        this.props.supLoading(flag)
    }
    // /** 获取类目树
    //  * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8036
    //  * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=214#8067
    //  * */
    // getList(flag=false,list=[]) {
    //     const { saleGoodsCertificateId } = this.props;
    //     const { categoryTree=[] } = this.state;
    //     let postData = {};
    //     if(!isEmpty(saleGoodsCertificateId)){
    //         postData["saleGoodsCertificateId"] = saleGoodsCertificateId;
    //     }
    //     // if(categoryTree.length==0){
    //         this.loading(true);
    //         postHttpAction('/service/mg/certificate/query-category-tree',postData, (resData) => {
    //             this.loading(false);
    //             const { success, valid, models=[]} = resData;
    //             if (success &&valid) {
    //                 const categoryList = this.pushCategoryItem(models)||[];
    //                 this.setState({
    //                     categoryTree:models,
    //                     categoryList:categoryList ,
    //                 });
    //                 const { selectedCategorySure={},}=this.props;
    //                 let cates = [];
    //                 for(let key in selectedCategorySure){
    //                     const has = categoryList.find(cate=>cate.id==key);
    //                     if(has&&!isEmptyObject(has)){ // 由于要求 已删除的类目需要显示 ，但保存时要过滤， 增 hadValid为true 才提交
    //                         selectedCategorySure[key].hadValid = true;
    //                         cates.push(key)
    //                     }
    //                 }
    //                 this.props.selectedCates(selectedCategorySure,true,cates);
    //
    //             }else if(resData.message){
    //                 message.warning(resData.message)
    //             }
    //         });
    //     // }
    // }
    // // 把所有类目都集中到一维数组
    // pushCategoryItem(list = []) {
    //     let arr = [];
    //     list.forEach((item) => {
    //         arr.push(item)
    //         if (item.subCategories) {
    //             arr = [...arr, ...item.subCategories, ...this.pushCategoryItem(item.subCategories)];
    //         }
    //     });
    //     return arr;
    // }
    /*
    *  处理 类目 层级选择后写入路径
    * */
    handleSelectItem(newSelects,level="1",curr,firstCate,secondCate,thirdCate){
        let {sortNum = 0 } = this.state;
        sortNum += 1;
        let path = []
        path[0] ={
            id: firstCate.id,
            code:firstCate.code,
            name:firstCate.name,
        }
        if(level>=2){
            path[1] = {
                id: secondCate.id,
                code:secondCate.code,
                name:secondCate.name,
            }
        }
        if(level>=3){
            path[2] = {
                id: thirdCate.id,
                code:thirdCate.code,
                name:thirdCate.name,
            }
        }
        if(level>=4){
            path[3] = {
                id: curr.id,
                code:curr.code,
                name:curr.name,
            }
        }
        newSelects[curr.id] = {
            id: curr.id,
            code:curr.code,
            name:curr.name,
            level:level,
            path:path,
            sort: sortNum,
            hadValid: true,
        }
        this.setState({
            sortNum: sortNum
        })
        return newSelects
    }
    /**
    *  普通选中事件
    *  @params check , 是不是选中
    *  @params level 级别 1：只有一层
    * */
    onChangeCheck(curr={},check=false,level=1) {
        const { selectedItems={},firstCate={},secondCate={},thirdCate={} } = this.state;
        let newSelects = {...selectedItems};
        if(check){
            newSelects = this.handleSelectItem(newSelects,level,curr,firstCate,secondCate,thirdCate);
        }else delete newSelects[curr.id]
        this.setState({
            selectedItems: newSelects
        })
    }
    /*
    *  级联组件搜索
    * */
    clearCascader(value){
        this.setState({
            sCascadeKey: value,
        })
    }
    onChangeCascader(value, ) {
        let oneLev = [],secondLev = [],thirdLev=[],fourthLev=[];
        const { categoryTree=[] } = this.state;
        if(!isEmpty(value)&&categoryTree.length>0){
            // oneLev = categoryTree.filter(cate=>cate.name.indexOf(value)>=0);
            categoryTree.forEach(one=>{
                if(one.name.indexOf(value)>=0){
                    oneLev.push(one)
                }
                if(one.subCategories&&one.subCategories.length>0){
                    one.subCategories.forEach(two=>{
                        if(two.name.indexOf(value)>=0){
                            const path = [
                                {
                                    id: one.id,
                                    code:one.code,
                                    name:one.name,
                                },
                                {
                                    id: two.id,
                                    code:two.code,
                                    name:two.name,
                                },
                            ]
                            secondLev.push({
                                id: two.id,
                                code:two.code,
                                name:two.name,
                                level:2,
                                path:path,
                            })
                        }
                        if(two.subCategories&&two.subCategories.length>0){
                            two.subCategories.forEach(third=>{
                                if(third.name.indexOf(value)>=0){
                                    const path = [
                                        {
                                            id: one.id,
                                            code:one.code,
                                            name:one.name,
                                        },
                                        {
                                            id: two.id,
                                            code:two.code,
                                            name:two.name,
                                        },
                                        {
                                            id: third.id,
                                            code:third.code,
                                            name:third.name,
                                        },
                                    ]
                                    thirdLev.push({
                                        id: third.id,
                                        code:third.code,
                                        name:third.name,
                                        level:3,
                                        path:path,
                                    })
                                }
                                if(third.subCategories&&third.subCategories.length>0){
                                    third.subCategories.forEach(fourth=>{
                                        if(fourth.name.indexOf(value)>=0){
                                            const path = [
                                                {
                                                    id: one.id,
                                                    code:one.code,
                                                    name:one.name,
                                                },
                                                {
                                                    id: two.id,
                                                    code:two.code,
                                                    name:two.name,
                                                },
                                                {
                                                    id: third.id,
                                                    code:third.code,
                                                    name:third.name,
                                                },{
                                                    id: fourth.id,
                                                    code:fourth.code,
                                                    name:fourth.name,
                                                },
                                            ]
                                            fourthLev.push({
                                                id: fourth.id,
                                                code:fourth.code,
                                                name:fourth.name,
                                                level:4,
                                                path:path,
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
            this.setState({
                sCascadeKey: value,
                lCascades : {
                    "one":oneLev||[],
                    "two":secondLev,
                    "third":thirdLev,
                    "fourth":fourthLev,
                }
            })
        }
        // else this.setState({
        //     sCascadeKey: value,
        // })
    }
    /**
     *  级联 选中事件
     *  @params check , 是不是选中
     *  @params level 级别 1：只有一层
     * */
    onSelectCascader(curr={},level=1){
        const { selectedItems={},} = this.state;
        let newSelects = {...selectedItems};
        if(level==2){
            newSelects =  this.handleSelectItem(newSelects,level,curr,curr.path[0],curr.path[1]);
        }else if(level==3||level==4){
            newSelects =  this.handleSelectItem(newSelects,level,curr,curr.path[0],curr.path[1],curr.path[2]); 
        }
        this.setState({
            selectedItems: newSelects
        })
    }
    /*
    * 修改类目显示 ，当修改级别时 隔一级要清空
    * 一级 firstCate //不会被修改
    * 二级 secondCate
    * 三级 thirdCate
    * 四级 fourCate
    * */
    changeCateLevel(name="firstCate",curr={},){
        const obj = this.state;
        let newObj = {...obj}
        newObj[name] = curr;
        if(name=="firstCate"){
            newObj["secondCate"] = {};
            newObj["thirdCate"] = {};
        }else if(name=="secondCate"){
            newObj["thirdCate"] = {};
        }
        this.setState(newObj)
    }
    /*
    * 渲染已选 项
    * type = 2，是显示 来自props 确定的已选数据
    * */
    getRenderCheck(selecteds={},type=1){
        let index = 0;
        const arr = Object.values(selecteds)
        arr.sort(this.sortByPJ);
        if(type==2){
            let childred = [];
            for(let item of arr){
                childred.push(<span className={"blueSpan flex-item-ver-center"} key={"level_lab_"+item.id}>
                    {this.toLevel(item)}
                    <i className={"ri-close-line black45 ml_4 cursor-p"}
                       onClick={(e)=>this.delete(e,item)}/>
                </span>)
                index += 1;
            }
            return childred;
        }else {
            let childred = "";
            for(let item of arr){
                const sCatePath = this.toLevel(item,true);
                if(sCatePath){
                    childred += (index>0?"，":"")+sCatePath;
                    index += 1;
                }
            }
            return childred;
        }
    }
   /**
   * 删除
   * */
    delete(e,item){
        e.preventDefault();
        const { selectedCategorySure } = this.props;
        let newSels = {...selectedCategorySure};
        delete newSels[item.id];
       this.props.selectedCates(newSels)
    }
    sortByPJ(a,b){
        return a.sort-b.sort;
    }
    toLevel(item={},check=false){
        if(!item.hadValid&&check){
            return ""
        }
        if(item.prdCategoryName) return item.prdCategoryName;
        switch (item.level) {
            case 1:
                return item.name;
            case 2:
               if(!item.path||item.path.length==0) return "";
               return (item.path[0]?item.path[0].name:"-") + ">" +(item.path[1]?item.path[1].name:"-");
            case 3:
                if(!item.path||item.path.length==0) return "";
                return (item.path[0]?item.path[0].name:"-") + ">...>" +(item.path[2]?item.path[2].name:"-");
            case 4:
                if(!item.path||item.path.length==0) return "";
                return  (item.path[0]?item.path[0].name:"-" )+ ">...>"  +(item.path[3]?item.path[3].name:"-");
            default:
               return ""
        }
    }
    /*
   * 渲染级联
   * */
    renderCascade(list=[],level=1){
      return list.map((item={},inx)=><div className={"downBox"} key={"level_"+level+"_"+inx}
                                            onMouseDown={e => e.preventDefault()}
                                            onClick={()=>this.onSelectCascader(item,level)}>
            {item.path.map((p,pInx)=><span key={inx+"_pa_"+pInx}>{pInx>0?" > "+p.name:p.name}</span>)}
        </div>)
    }
    openModal(flag=false){
        if(flag){
            // this.getList();
            this.setState({
                selectedItems: this.props.selectedCategorySure||{},
                show: true
            })
        }else {
            this.setState({
                show:flag,
            })
            this.timer = setTimeout(()=>{
                this.setState({
                    sCascadeKey:""
                })
            },400);
        }
    }
    /**
     * 点击确认
     * */
    handleOk(){
        const { selectedItems={} } = this.state;
        this.openModal(false);
        for(let key in selectedItems){
            const cate = selectedItems[key];
            if(!cate.hadValid){
                delete selectedItems[key];
            }
        }
        this.props.selectedCates(selectedItems);
    }

    componentWillMount() {
    };
    componentWillUnmount(){
        this.setState = ()=>false;
        clearTimeout(this.timer);
    }
    render() {
        const { selectedCategorySure={},categoryTree=[],}=this.props;
        const { show=false,selectedItems={},firstCate={},secondCate={},thirdCate={},sCascadeKey="",lCascades={}} = this.state;
            // console.log("类目 selectedCategorySure,",selectedItems)
        return (<>
            {isEmptyObject(selectedCategorySure)?<div className={"black89 font_14 categorySelectWrap ant-input mb_12"}
                                                   onClick={()=>this.openModal(true)}><span className={"black66 cursor-p"}>
                {Lang({id: 'QingXuanZeLeiMu', default: '请选择类目'})}
                </span>
            </div>:<div className={"black89 font_14 categorySelectWrap ant-input mb_12"}>
                {this.getRenderCheck(selectedCategorySure,2)}
                <div className={"selBg"} onClick={()=>this.openModal(true)}/>
            </div>}
            <EssaModal title={Lang({id:"ZhengShuXuanZe",default:"类目选择"})}
                open={show}
                width={930}
                onOk={()=>this.handleOk()}
                onCancel={()=>this.openModal(false)}>
                {<Select // mode="tags"
                        showSearch
                        style={{ width: '100%' }}
                        placeholder={Lang({id:'QingShuRu', default:'请输入'})}
                        allowClear
                        value={sCascadeKey||Lang({id:'QingShuRu', default:'请输入'})}
                        onChange={value=>this.clearCascader(value)}
                        onSearch={(value)=>this.onChangeCascader(value)}
                        dropdownRender={(menuNode)=><div className={"selectDropDownWrap black89"}>
                            {/* 只有一级的 */}
                            {lCascades.one&&lCascades.one.length>0?lCascades.one.map((cateOne,inx)=><div className={"downBox"} key={"level1"+"_"+inx}
                                                                                                   onMouseDown={e => e.preventDefault()}
                                                                                                   onClick={()=>this.onChangeCheck(cateOne,true,1)}>
                                {cateOne.name}</div>):null}
                            {/* 二级的 two */}
                            {this.renderCascade(lCascades.two,2)}
                            {this.renderCascade(lCascades.third,3)}
                            {this.renderCascade(lCascades.fourth,4)}
                        </div>}
                />}
                <div className={"cateWrap mt_10 flex-item"}>
                    <div className={"cateList"}>
                        {categoryTree.map((cateFirst={},inx)=>{return(<div className={`mb_4 cateItem flex-item-between${cateFirst.id==firstCate.id?" cateItemCurr":""}`}
                                                                           key={cateFirst.id+"_"+inx}
                                                                           onMouseOver={()=>this.changeCateLevel("firstCate",cateFirst)}>
                            <div className={"leftTitle"}>
                                <Checkbox onChange={(e)=>this.onChangeCheck(cateFirst,e.target.checked,1)}
                                          checked={selectedItems[cateFirst.id]} />
                                <span className={"ml_4"}>{cateFirst.name}</span>
                            </div>
                            {cateFirst.subCategories&&cateFirst.subCategories.length>0?<span className={"ri-arrow-right-s-line"}></span>:null}
                        </div>)})}
                    </div>
                    <div className={"cateList"}>
                        {(firstCate.subCategories||[]).map((cateSecond={},inx)=>{return(<div className={`mb_4 cateItem flex-item-between${cateSecond.id==secondCate.id?" cateItemCurr":""}`}
                                                                                              key={cateSecond.id+"_"+inx}
                                                                       onMouseOver={()=>this.changeCateLevel("secondCate",cateSecond)}>
                            <div className={"leftTitle"}>
                                <Checkbox onChange={(e)=>this.onChangeCheck(cateSecond,e.target.checked,2)}
                                          checked={selectedItems[cateSecond.id]} />
                                <span className={"ml_4"}>{cateSecond.name}</span>
                            </div>
                            {cateSecond.subCategories&&cateSecond.subCategories.length>0?<span className={"ri-arrow-right-s-line"}></span>:null}
                        </div>)})}
                    </div>
                    <div className={"cateList"}>
                        {(secondCate.subCategories||[]).map((cateThird={},inx)=>{return(<div className={`mb_4 cateItem flex-item-between${cateThird.id==thirdCate.id?" cateItemCurr":""}`}
                                                                                            key={cateThird.id+"_"+inx}
                                                                          onMouseOver={()=>this.changeCateLevel("thirdCate",cateThird,)}>
                            <div className={"leftTitle"}>
                                <Checkbox onChange={(e)=>this.onChangeCheck(cateThird,e.target.checked,3)}
                                          checked={selectedItems[cateThird.id]} />
                                <span className={"ml_4"}>{cateThird.name}</span>
                            </div>
                            {cateThird.subCategories&&cateThird.subCategories.length>0?<span className={"ri-arrow-right-s-line"}></span>:null}
                        </div>)})}
                    </div>
                    <div className={"cateList"}>
                        {(thirdCate.subCategories||[]).map((cateFour={},inx)=>{return(<div className={"mb_4 cateItem flex-item-between"} key={cateFour.id+"_"+inx}>
                            <div className={"leftTitle"}>
                                <Checkbox onChange={(e)=>this.onChangeCheck(cateFour,e.target.checked,4)}
                                          checked={selectedItems[cateFour.id]} />
                                <span className={"ml_4"}>{cateFour.name}</span>
                            </div>
                        </div>)})}
                    </div>
                </div>
                <div className={"mt_10"}>
                    <Alert message={<div className={"flex-item black89 font_14"}>
                        {Lang({id:"YiXuan",default:"已选"})}：{this.getRenderCheck(selectedItems)}
                    </div>} type="warning" showIcon />
                </div>
            </EssaModal>
        </>);
    }
}

